var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-autocomplete',{attrs:{"items":_vm.items,"label":"Licence Category","value":_vm.value,"disabled":_vm.disabled,"rules":_vm.rules},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }